export default __webpack_public_path__ + "static/media/CNo.86-3.23f42596.jpg";